import { getEnvVariable } from "../../../modules/environmentalList"

const UserAdd = {
    "type": "popup",
    "key": "UserAdd",
    "name": "UserAdd",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'switchOpen'
    },
    sharedValues: ['open'],
    container: {
        values: {
            // SubModuleKey: '', SitePermitTypeId: '',
            SITE: '', ROLES: '', Users: '', save: false, back: false, fullscreen: false,
            exitfullscreen: false, CurrentlyAssigned: 'Y', Futureworkflow: 'Y'
        },
        mapValues: {
            header: [
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
            ],
            Users: [{ key: 'save', name: 'save' },
            { key: 'exitfullscreen', name: 'exitfullscreen' },
            { key: 'fullscreen', name: 'fullscreen' },
            // { key: 'SubModuleKey', name: 'SubModuleKey' },
            // { key: 'SitePermitTypeId', name: 'SitePermitTypeId' },
            { key: 'SITE', name: 'SITE' },
            { key: 'ROLES', name: 'ROLES' },
            { key: 'Users', name: 'Users' },
            { key: 'CurrentlyAssigned', name: 'CurrentlyAssigned' },
            { key: 'Futureworkflow', name: 'Futureworkflow' },
            ]
        },
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: 'row mx-1',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12 ',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],
            },
            {
                order: 1,
                type: 'div',
                className: 'row mx-1 mt-4',
                components: [{
                    name: 'Users',
                    type: 'div',
                    className: 'col-12 ',
                    sub: {
                        type: 'div',
                        className: 'col-12  ',
                    }
                }],
            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Users',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "Users", "materialicon": "note", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'FullScreen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit FullScreen'
                    }
                ],
            },
            Users: {
                "type": "form",
                "key": "Users",
                "name": "Users",
                aliases: {
                    save: 'save',
                },
                "routeParams": { replace: 'users', param: 'Id', routeName: 'id' },
                sharedValues: //['SubModuleKey', 'SitePermitTypeId', 
                    ['SITE', 'ROLES', 'Users', 'save', 'back', 'exitfullscreen', 'fullscreen'],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row ',
                            components: [{
                                name: 'SwitchUserList',
                                type: 'div',
                                className: ' col-10',
                                sub: {
                                    type: 'div',
                                    className: ' col-10',
                                }
                            }],
                        },
                        {
                            order: 1,
                            type: 'div',
                            className: 'row ',
                            components: [
                                {
                                    name: 'UserSave',
                                    type: 'div',
                                    className: ' col-2',
                                    sub: {
                                        type: 'div',
                                        className: ' col-2',
                                    }
                                },
                            ]
                        }
                    ],
                },
                values: {
                    SwitchUserList: '',
                    // SubModuleKey: '',
                    // SitePermitTypeId :'',
                    SITE: '',
                    ROLES: '',
                    Users: '',
                    UserSave: false,
                    GetParentValues: { 'name': 'modules' },
                    portal: getEnvVariable('AccessPortal'),
                },
                removeValues: [
                    'GetParentValues', 'Id',
                ],
                "components": {
                    SwitchUserList: {
                        "type": "switchuser",
                        "key": "SwitchUser",
                        "name": "SwitchUserList",
                        height: '500px',
                        showConfirmation: true,
                        message: 'Are you sure you want to switch user for the selected records?',
                        extraProps: {
                            transformProps: {
                                label: 'FullName',
                                value: 'UserId',
                                description: 'Email',
                            },
                        }
                    },
                    UserSave: {
                        "type": "workflowitems",
                        "key": "UserSave",
                        "label": "UserSave",
                        "name": "UserSave",
                        isVisible: false,
                        saveUsers: true,
                    }
                },
                mapActionsToEffects: {
                    'onLoad': {
                        init: {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'load',
                                            name: 'SwitchUserList',
                                            "read": [
                                                {
                                                    url: getEnvVariable('MasterAdmin') + `/api/InternalAccessControlView/GetUsersByConfigIdAndRoleId/{SITE}/` + getEnvVariable('ConfigType') + `/{ROLES}/` + getEnvVariable('ModuleKey'),
                                                    type: 'get',
                                                    "matchProps": [
                                                        {
                                                            name: 'SITE',
                                                            key: 'SITE',
                                                        },
                                                        {
                                                            name: 'ROLES',
                                                            key: 'ROLES',
                                                        },
                                                    ],
                                                    saveAs: {
                                                        key: 'items'
                                                    }
                                                },
                                            ],
                                        },
                                    ]
                                }
                            }]
                        },
                        'exitfullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'exitfullscreen',
                                            },
                                        ]
                                    }
                                }
                            ]
                        },
                        'fullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'fullscreen',
                                            },
                                        ]
                                    }
                                }
                            ]
                        },
                    },
                    'onChange': {
                        'SwitchUserList': {
                            fields: [
                                'SwitchUserList'
                            ],
                            rules: [
                                {
                                    fields: ['SwitchUserList'],
                                    run: {
                                        valid: [
                                            { type: "prop", name: "UserSave", valueType: 'D', value: true, hasValue: true },
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                }
            }
        },
    }
}

export default UserAdd